export const Countries = {
  countries: [
    {
      id: 101,
      name: "Germany",
      shortName: "DE",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 12.5 },
          monthly: { enabled: true, price: 3.9 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.23,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 18.0 },
          monthly: { enabled: true, price: 6.5 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.065,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.012,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 9.0 },
          monthly: { enabled: true, price: 2.5 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.018,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 25.0 },
          monthly: { enabled: true, price: 7.9 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.095,
          },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: false, price: 0.0 },
          monthly: { enabled: true, price: 1.2 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.031,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.004,
          },
        },
      },
    },
    {
      id: 102,
      name: "France",
      shortName: "FR",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 10.0 },
          monthly: { enabled: true, price: 4.2 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.027,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 16.5 },
          monthly: { enabled: true, price: 7.1 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.072,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.015,
          },
        },
        national: {
          payPeriod: "per Second",
          activation: { enabled: true, price: 8.5 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.02,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 27.0 },
          monthly: { enabled: true, price: 8.9 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.11,
          },
        },
      },
    },
    {
      id: 103,
      name: "Japan",
      shortName: "JP",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 1400 },
          monthly: { enabled: true, price: 520 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 3.2,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 2100 },
          monthly: { enabled: true, price: 880 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 8.6,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 1.1,
          },
        },
        tollfee: {
          payPeriod: "per Second",
          activation: { enabled: false, price: 0 },
          monthly: { enabled: true, price: 1200 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 12.0,
          },
        },
        random: {
          payPeriod: "per Second",
          activation: { enabled: true, price: 600 },
          monthly: { enabled: false, price: 0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 4.4,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.6,
          },
        },
      },
    },
    {
      id: 104,
      name: "Brazil",
      shortName: "BR",
      options: {
        landline: {
          payPeriod: "per Second",
          activation: { enabled: true, price: 39.9 },
          monthly: { enabled: true, price: 12.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.19,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Second",
          activation: { enabled: true, price: 55.0 },
          monthly: { enabled: true, price: 18.5 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.42,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.06,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: false, price: 0.0 },
          monthly: { enabled: true, price: 9.9 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.15,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 12.0 },
          monthly: { enabled: true, price: 4.5 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.03,
          },
        },
      },
    },
    {
      id: 105,
      name: "Canada",
      shortName: "CA",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 14.0 },
          monthly: { enabled: true, price: 5.5 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.021,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.4,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 22.0 },
          monthly: { enabled: true, price: 8.2 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.069,
          },
          inboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 11.0 },
          monthly: { enabled: true, price: 3.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.017,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 29.0 },
          monthly: { enabled: true, price: 9.5 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.085,
          },
        },
      },
    },
    {
      id: 106,
      name: "Australia",
      shortName: "AU",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 15.0 },
          monthly: { enabled: true, price: 6.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.03,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: false, price: 0.0 },
          monthly: { enabled: true, price: 9.2 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.085,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.02,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 10.0 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.024,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 4.5 },
          monthly: { enabled: true, price: 1.9 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.041,
          },
          inboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
        },
      },
    },
    {
      id: 107,
      name: "India",
      shortName: "IN",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 499 },
          monthly: { enabled: true, price: 199 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.9,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 799 },
          monthly: { enabled: true, price: 349 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 1.6,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.3,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 299 },
          monthly: { enabled: true, price: 149 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.7,
          },
          inboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 999 },
          monthly: { enabled: true, price: 499 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 2.8,
          },
        },
      },
    },
    {
      id: 108,
      name: "South Africa",
      shortName: "ZA",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 210.0 },
          monthly: { enabled: true, price: 79.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.42,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 320.0 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.88,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.12,
          },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: false, price: 0.0 },
          monthly: { enabled: true, price: 35.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.55,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.05,
          },
        },
      },
    },
    {
      id: 109,
      name: "Mexico",
      shortName: "MX",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 190.0 },
          monthly: { enabled: true, price: 69.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.35,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 260.0 },
          monthly: { enabled: true, price: 110.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.95,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.14,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: false, price: 0.0 },
          monthly: { enabled: true, price: 55.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.28,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 420.0 },
          monthly: { enabled: true, price: 160.0 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 1.25,
          },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 60.0 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.44,
          },
          inboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
        },
      },
    },
    {
      id: 110,
      name: "Sweden",
      shortName: "SE",

      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 110.0 },
          monthly: { enabled: true, price: 39.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.22,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 160.0 },
          monthly: { enabled: true, price: 59.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.65,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.09,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 80.0 },
          monthly: { enabled: true, price: 29.0 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: false, price: 0.0 },
          monthly: { enabled: true, price: 75.0 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 1.1,
          },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 25.0 },
          monthly: { enabled: true, price: 9.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.31,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.04,
          },
        },
      },
    },
    {
      id: 111,
      name: "Israel",
      shortName: "IL",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 12.0 },
          monthly: { enabled: true, price: 5.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.15,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.05,
          },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 18.0 },
          monthly: { enabled: true, price: 7.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.25,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.08,
          },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 8.0 },
          monthly: { enabled: true, price: 3.0 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.10,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.0,
          },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 20.0 },
          monthly: { enabled: true, price: 6.0 },
          outboundRate: {
            enabled: false,
            pricePerMinute: 0.0,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.12,
          },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 10.0 },
          monthly: { enabled: true, price: 3.5 },
          outboundRate: {
            enabled: true,
            pricePerMinute: 0.20,
          },
          inboundRate: {
            enabled: true,
            pricePerMinute: 0.03,
          },
        },
      },
    },
    {
      id: 117,
      name: "South Korea",
      shortName: "KR",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 12.5 },
          monthly: { enabled: true, price: 4.5 },
          outboundRate: { enabled: true, pricePerMinute: 0.2 },
          inboundRate: { enabled: true, pricePerMinute: 0.05 },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 18.0 },
          monthly: { enabled: true, price: 7.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.25 },
          inboundRate: { enabled: true, pricePerMinute: 0.06 },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 7.0 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.12 },
          inboundRate: { enabled: true, pricePerMinute: 0.0 },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 21.0 },
          monthly: { enabled: true, price: 6.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.3 },
          inboundRate: { enabled: true, pricePerMinute: 0.08 },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 8.5 },
          monthly: { enabled: true, price: 2.8 },
          outboundRate: { enabled: true, pricePerMinute: 0.18 },
          inboundRate: { enabled: true, pricePerMinute: 0.05 },
        },
      },
    },
    {
      id: 119,
      name: "Turkey",
      shortName: "TR",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 9.0 },
          monthly: { enabled: true, price: 4.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.2 },
          inboundRate: { enabled: true, pricePerMinute: 0.03 },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 16.0 },
          monthly: { enabled: true, price: 6.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.3 },
          inboundRate: { enabled: true, pricePerMinute: 0.05 },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 7.5 },
          monthly: { enabled: true, price: 3.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.1 },
          inboundRate: { enabled: true, pricePerMinute: 0.0 },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 21.0 },
          monthly: { enabled: true, price: 6.5 },
          outboundRate: { enabled: false, pricePerMinute: 0.0 },
          inboundRate: { enabled: true, pricePerMinute: 0.12 },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 5.5 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.3 },
          inboundRate: { enabled: true, pricePerMinute: 0.05 },
        },
      },
    },
    {
      id: 120,
      name: "Argentina",
      shortName: "AR",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 10.0 },
          monthly: { enabled: true, price: 4.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.18 },
          inboundRate: { enabled: true, pricePerMinute: 0.0 },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 20.0 },
          monthly: { enabled: true, price: 7.5 },
          outboundRate: { enabled: true, pricePerMinute: 0.32 },
          inboundRate: { enabled: true, pricePerMinute: 0.06 },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 9.0 },
          monthly: { enabled: true, price: 3.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.2 },
          inboundRate: { enabled: true, pricePerMinute: 0.0 },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 25.0 },
          monthly: { enabled: true, price: 8.0 },
          outboundRate: { enabled: false, pricePerMinute: 0.0 },
          inboundRate: { enabled: true, pricePerMinute: 0.1 },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 12.0 },
          monthly: { enabled: true, price: 4.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.25 },
          inboundRate: { enabled: false, pricePerMinute: 0.0 },
        },
      },
    },
    {
      id: 121,
      name: "Egypt",
      shortName: "EG",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 9.0 },
          monthly: { enabled: true, price: 4.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.25 },
          inboundRate: { enabled: true, pricePerMinute: 0.03 },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 17.0 },
          monthly: { enabled: true, price: 6.5 },
          outboundRate: { enabled: true, pricePerMinute: 0.3 },
          inboundRate: { enabled: true, pricePerMinute: 0.07 },
        },
      },
    },
    {
      id: 123,
      name: "Saudi Arabia",
      shortName: "SA",
      options: {
        landline: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 15.0 },
          monthly: { enabled: true, price: 6.5 },
          outboundRate: { enabled: true, pricePerMinute: 0.35 },
          inboundRate: { enabled: true, pricePerMinute: 0.0 },
        },
        mobile: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 25.0 },
          monthly: { enabled: true, price: 10.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.45 },
          inboundRate: { enabled: true, pricePerMinute: 0.1 },
        },
        national: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 10.0 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.25 },
          inboundRate: { enabled: true, pricePerMinute: 0.05 },
        },
        tollfee: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 35.0 },
          monthly: { enabled: true, price: 13.5 },
          outboundRate: { enabled: false, pricePerMinute: 0.0 },
          inboundRate: { enabled: true, pricePerMinute: 0.12 },
        },
        random: {
          payPeriod: "per Minutes",
          activation: { enabled: true, price: 10.0 },
          monthly: { enabled: false, price: 0.0 },
          outboundRate: { enabled: true, pricePerMinute: 0.3 },
          inboundRate: { enabled: true, pricePerMinute: 0.08 },
        },
      },
    },

  ],
};
